export default "__VITE_ASSET__C3a2c_jf__"